import React from 'react';
import PropTypes from 'prop-types';

const AllHighlightedFeaturesLink = ({ onClick, displayText }) => {
	return (
		<button
			type="button"
			className="text-link text-decoration-underline text-link-muted mt-4"
			ui-tabs-initial-load="false"
			onClick={onClick}
		>
			<span className="ddc-font-size-xsmall">{displayText}</span>
		</button>
	);
};

AllHighlightedFeaturesLink.propTypes = {
	onClick: PropTypes.func,
	displayText: PropTypes.string
};

export default AllHighlightedFeaturesLink;
